/*global jQuery:false */
var QUEO = window.QUEO ||{};

QUEO.Accessibility = (function($) {

    var _$d = $(document);

    // Note: the additionalOffset if not set defaults to '1' since the scrolled header has a border-bottom of 1px.
    // Ideally we would just calculate the current outline and use that as offset, but this will be unnecessarily
    // complicated (treating negative outline-offset right, stuff works differently for styled selects, etc.).

    // bind elements for adjustFocusPosition (separated into different selector groups due to different outline offsets)
    _$d.on('focus', '.content button, .content .ph-button, .content input:not([type="hidden"]), .content select, .content textarea', {additionalOffset: 4}, adjustFocusPosition);
    _$d.on('focus', '.content a:not(.ph-button)', {additionalOffset: 3}, adjustFocusPosition);

    // accessibility helper for focused (form) elements which may be underneath the sticky header (shift + tab)
    function adjustFocusPosition(e) {

        var headerHeight = $('.js-header').outerHeight() || 0,
            elementOffset = $(this).offset().top,
            // Note: we always need an additional offset because at least scrolled header has 1px border
            additionalOffset = e.data && e.data.hasOwnProperty('additionalOffset') ? e.data.additionalOffset : 1;

        // underneath the header therefore we adjust scroll position
        if(elementOffset - window.scrollY - headerHeight < 0) {
            window.scroll(window.scrollX,elementOffset - headerHeight - additionalOffset);
        }

    }

    // bind focus handling for checkbox inside label (when being clicked on)
    _$d.on('click', '.c-checkbox-switch', function(e) {

        if(!$(e.target).is('input')) {

            $(this).find('input').one('focus', _blur);

        }

    });
    // bind focus handling checkbox/radio (when being clicked on)
    _$d.on('click', 'input + label', function() {

        $(this).prev('input').one('focus', _blur);

    });
    function _blur(e) {

        e.preventDefault();

        $(this).blur();

    }

    // focus handling for links and buttons (those elements should receive :focus when being tabbed only)
    $(document).on('mousedown focus', 'a,button', function(e) {

        var $el = $(this),
            tabFocus = $el.data('tab-focus');

        if(typeof tabFocus === 'undefined') {

            setTabFocus($el, true);
            tabFocus = true;

        }

        if(e.type === 'mousedown') {

            setTabFocus($el, false);
            $el.blur();

        } else {

            if(!tabFocus) {

                $el.blur();

                // Note: following (rAF + return) is a fix for quirky Firefox behaviour when navigating back
                requestAnimationFrame(function() {

                    setTabFocus($el, true);

                });

                return;

            }

            setTabFocus($el, true);

        }

    });
    function setTabFocus($el, isActive) {

        $el.data('tab-focus', isActive);

    }

})(jQuery);